export default "__VITE_ASSET__Dd2EWIKo__"